const locale = {
  placeholder: 'Wybierz godzinę',
};

export default locale;
